/* @ngInject */
const local = (
  valueHandler,

  storageHandler
) => {
  const self = {}

  self.saveCurrentId = (_id) => {
    if (valueHandler.isId(_id)) {
      storageHandler.save('currentCommandeId', _id)
    } else if (valueHandler.isId(_id.id)) {
      storageHandler.save('currentCommandeId', _id.id)
    }
  }

  self.getCurrentId = () => {
    return storageHandler.get('currentCommandeId')
  }

  return self
}

export default local



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/services/local.service.js